const Type = {
  AUTHORIZE: 'authorize',
  DIRECT_CAPTURE: 'direct_capture',
  AUTHENTICATE: 'authenticate',
};

module.exports = Type;
